<navigation [navigationDetails]="navigationDetails">
    <transaction-header-light [defaultTitleKey]="title" [accessLevel]="accessLevel"></transaction-header-light>
    <div class="standard-form">
        <notification [notificationDetails]="error">
        </notification>
    </div>
    <div class="fm-buttons"></div>
</navigation>
